export default __webpack_public_path__ + "static/char-s-09-kr-5012888539ee9c50d655f9cc281e7d81.webp";